<!-- 抽屉组件 -->
<template>
  <div :class="[show ? 'drawerOpen drawer-box' : 'drawer-box' ]">
      <div class="drawer-mask" @click.stop="onClose"></div>
      <div class="drawer-body-wrapper drawerFadeInRight">
            <div class="drawer-body">
                <div class="drawer-header">
                    <span class="drawer-title">{{title}}</span>
                    <span class="drawer-icon-close" @click="onClose"><i class="el-icon-error"></i></span>
                </div>
                <div class="drawer-content">
                    <slot name="drawerBody"></slot>
                    <slot></slot>
                </div>
                <div class="drawer-footer">
                    <el-button @click="onClose">取消</el-button>
                    <el-button type="primary" @click="onSubmit">确认</el-button>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: 'cmpdrawer',
  props: ['title','show'],
  data () {
    return {
        // bool: this.show
    };
  },
  methods: {
    //   取消
    onClose() {
       this.$emit('onClose')
    },
    // 确定
    onSubmit() {
        this.$emit('submit')
    },
  },
//   watch: {
//       show(val) {
//           this.bool = val
//       }
//   },

}

</script>
<style lang='less' scoped>
.drawer-box{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    overflow: hidden;
    z-index: 9999999;
    .drawer-mask{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        opacity: 0;
        z-index: 9998;
        background-color: rgba(0,0,0,0.65);
        transform: translateX(100%);
        -webkit-transition: -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: transform .3s cubic-bezier(.9, 0, .3, .7), -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
    }
    .drawer-body-wrapper{
        position: fixed;
        height: 100%;
        right: 0;
        width: 50%;
        min-width: 850px;
        z-index: 9999;
        transform: translateX(100%);
        -webkit-transition: -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: transform .3s cubic-bezier(.9, 0, .3, .7);
        transition: transform .3s cubic-bezier(.9, 0, .3, .7), -webkit-transform .3s cubic-bezier(.9, 0, .3, .7);
        .drawer-body{
            position: relative;
            width: 100%;
            height: 100%;
            overflow: hidden;
            background-color: #fff;
            .drawer-header{
                padding: 16px 24px;
                border-radius: 4px 4px 0 0;
                background: #fff;
                color: rgba(0,0,0,0.65);
                border-bottom: 1px solid #e8e8e8;
                position: relative;
                .drawer-title{
                    margin: 0;
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 500;
                    color: rgba(0,0,0,0.85);
                }
                .drawer-icon-close{
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 54px;
                    height: 54px;
                    line-height: 54px;
                    font-size: 16px;
                    text-align: center;
                    cursor: pointer;
                    i{
                        transition: All .4s ease-in-out;
                    }
                    &:hover i{
                        color: #3a8ee6;
                        transform: rotate(180deg);
                    }
                }
            }
            .drawer-content{
                height: calc(100% - 108px);
                padding: 24px;
                font-size: 14px;
                line-height: 1.5;
                word-wrap: break-word;
                overflow: auto;
                box-sizing: border-box;
            }
            .drawer-footer{
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                z-index: 10000;
                border-top: 1px solid rgb(233, 233, 233);
                padding: 10px 16px;
                background: rgb(255, 255, 255);
                text-align: right;
            }
        }
    }
    &.drawerOpen{
        width: 100%;
        .drawer-mask{
            transform: translateX(0);
            opacity: .5;
        }
        .drawer-body-wrapper{
            box-shadow: -2px 0 8px rgba(0,0,0,0.15);
            transform: translateX(0);
        }
    }
}
</style>